import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { ClientListView } from '@/features/clients/ClientListView'

export const Route = createFileRoute('/clients/')({
  component: () => (
    <AdminGuard>
      <ClientListView />
    </AdminGuard>
  ),
})
